// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"486":"0c734a8b","821":"96cbd68d"}[chunkId] + ".chunk.js";
};